
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_245_646)"}},[_c('path',{attrs:{"d":"M9.981 10.019L7 12.999l-2.981-2.98A4.19 4.19 0 000 14.199v.3A1.5 1.5 0 001.5 16h11a1.5 1.5 0 001.5-1.5v-.3a4.19 4.19 0 00-4.019-4.18zM.425 2.494l.2.046v1.825A.741.741 0 00.25 5c0 .262.144.481.347.615L.109 7.562C.056 7.778.175 8 .347 8h1.306c.172 0 .29-.222.238-.438l-.488-1.947A.739.739 0 001.75 5a.741.741 0 00-.375-.635V2.722l2.063.497A3.97 3.97 0 003 4.999a4 4 0 108 0c0-.643-.166-1.243-.438-1.78l3.01-.725c.569-.138.569-.847 0-.985L7.622.072a2.684 2.684 0 00-1.24 0L.424 1.506c-.566.138-.566.85 0 .988z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_245_646"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v16H0z"}})])])])
          )
        }
      }
    